import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// https://observablehq.com/@mbostock/saving-svg@114
import define1 from "./9d7cc1d26bcca7c7@262.js";
export default function define(runtime, observer) {
  var main = runtime.module();
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject || (_templateObject = _taggedTemplateLiteral(["# Saving SVG\n\n<figure style=\"display:flex;padding:10px;background:#fefedd;color:#444;font:15px/22px var(--sans-serif);\">\n<div style=\"margin:10px;\"><b>Update:</b> Saving SVG is now built-in! Open the cell menu <svg viewBox=\"0 0 8 14\" fill=\"currentColor\" stroke=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" width=\"8\" height=\"14\"><circle r=\"1.5\" cx=\"4\" cy=\"2\"></circle><circle r=\"1.5\" cx=\"4\" cy=\"7\"></circle><circle r=\"1.5\" cx=\"4\" cy=\"12\"></circle></svg> in the left margin to download any SVG cell as either SVG or PNG.</div>\n<div><img src=\"https://user-images.githubusercontent.com/4732/57958244-0ed81780-78b4-11e9-859d-bc68cc4f45b6.png\"></div>\n</figure>\n\nSay we have a dynamically-generated SVG, like this contour plot. Here\u2019s how might you save it to a file in Observable using DOM.download."])));
  });
  var child1 = runtime.module(define1);
  main.import("chart", child1);
  main.variable(observer()).define(["chart"], function (chart) {
    return chart;
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["You can serialize the SVG element as a string, and then download it as an SVG file."])));
  });
  main.variable(observer()).define(["DOM", "serialize", "chart"], function (DOM, serialize, chart) {
    return DOM.download(function () {
      return serialize(chart);
    }, undefined, "Save as SVG");
  });
  main.variable(observer("serialize")).define("serialize", ["NodeFilter"], function (NodeFilter) {
    var xmlns = "http://www.w3.org/2000/xmlns/";
    var xlinkns = "http://www.w3.org/1999/xlink";
    var svgns = "http://www.w3.org/2000/svg";
    return function serialize(svg) {
      svg = svg.cloneNode(true);
      var fragment = window.location.href + "#";
      var walker = document.createTreeWalker(svg, NodeFilter.SHOW_ELEMENT);

      while (walker.nextNode()) {
        var _iterator = _createForOfIteratorHelper(walker.currentNode.attributes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attr = _step.value;

            if (attr.value.includes(fragment)) {
              attr.value = attr.value.replace(fragment, "#");
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      svg.setAttributeNS(xmlns, "xmlns", svgns);
      svg.setAttributeNS(xmlns, "xmlns:xlink", xlinkns);
      var serializer = new window.XMLSerializer();
      var string = serializer.serializeToString(svg);
      return new Blob([string], {
        type: "image/svg+xml"
      });
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Alternatively, you can render the SVG to a canvas to generate a PNG."])));
  });
  main.variable(observer()).define(["DOM", "rasterize", "chart"], function (DOM, rasterize, chart) {
    return DOM.download(function () {
      return rasterize(chart);
    }, undefined, "Save as PNG");
  });
  main.variable(observer("rasterize")).define("rasterize", ["DOM", "serialize"], function (DOM, serialize) {
    return function rasterize(svg) {
      var resolve, reject;
      var promise = new Promise(function (y, n) {
        return resolve = y, reject = n;
      });
      var image = new Image();
      image.onerror = reject;

      image.onload = function () {
        var rect = svg.getBoundingClientRect();
        var context = DOM.context2d(rect.width, rect.height);
        context.drawImage(image, 0, 0, rect.width, rect.height);
        context.canvas.toBlob(resolve);
      };

      image.src = URL.createObjectURL(serialize(svg));
      return promise;
    };
  });
  main.variable(observer()).define(["md"], function (md) {
    return md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["To use this in your own notebook, import from this notebook:\n\n```js\nimport {rasterize} from \"@mbostock/saving-svg\"\n```\n\nHappy downloading!"], ["To use this in your own notebook, import from this notebook:\n\n\\`\\`\\`js\nimport {rasterize} from \"@mbostock/saving-svg\"\n\\`\\`\\`\n\nHappy downloading!"])));
  });
  return main;
}